import React from 'react';
import {MdOutlineStar} from 'react-icons/md';
import {books} from '../../content/books/books';
import {bookCoverMap} from '../../content/books/book-covers';
import './BookSpotlight.css';

export default function BookSpotlight({book, variant = 'default'}) {
  const currentBook = book ?? books.find((b) => b.isLatest) ?? books[0];

  const cover = bookCoverMap[currentBook.coverKey];
  const home = currentBook.home ?? {};

  return (
    <div className={`book-spotlight ${variant} py-4 py-md-5 px-3`}>
      <div className='book-row'>
        <h3 className='mb-4'>{currentBook.title.toUpperCase()}</h3>

        <div className='row'>
          <div className='col-12 col-md-6 order-2 order-md-1 p-md-0'>
            {cover ? (
              <img
                src={cover}
                alt={`${currentBook.title} cover`}
                className='img-fluid pt-4'
              />
            ) : null}
          </div>

          <div className='col-12 col-md-6 order-1 order-md-2'>
            {home.kicker ? <h2>{home.kicker}</h2> : null}
            {home.publisherLine ? <p>{home.publisherLine}</p> : null}
            {home.highlight ? (
              <p className='book-highlight'>{home.highlight}</p>
            ) : null}

            {home.homeBlurb?.map((p, i) => (
              <p
                key={i}
                className='pt-3'>
                {p}
              </p>
            ))}

            {/* Keep this line if you really want repeated title; otherwise remove */}
            <p className='book-highlight'>{currentBook.title.toUpperCase()}</p>

            {/* This line should depend on variant (see #2) */}
            {variant === 'next' ? (
              <p className='status-line'>
                Coming soon — available to pre-order now.
              </p>
            ) : (
              <p className='status-line'>
               Get your copy in supermarkets, bookshops and online.
              </p>
            )}

            {home.regionLinks?.length ? (
              <div className='mb-4'>
                {home.regionTitle ? <p>{home.regionTitle}</p> : null}

                {home.regionLinks.map((l) => (
                  <p key={l.url}>
                    <a
                      href={l.url}
                      target='_blank'
                      rel='noreferrer'
                      className={`py-1 px-2 ${l.className ?? 'link2'}`}>
                      {l.label}
                    </a>
                  </p>
                ))}
              </div>
            ) : null}
          </div>
        </div>

        {home.starQuotes?.map((q, i) => (
          <div
            key={i}
            className='starreviewsection mt-5'>
            <p className='stars mb-1'>
              <MdOutlineStar /> <MdOutlineStar /> <MdOutlineStar />{' '}
              <MdOutlineStar /> <MdOutlineStar />
            </p>
            <p className='my-0 mb-2'>‘{q.text}’</p>
            <p className='author my-0'>{q.author.toUpperCase()}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
